import React, { Component } from "react";

import Flange from "./../componentes/Flange";
import SvgSetter from "./SvgSetter";

import * as FenIcon from "./../../constants/icons/fenomenes/Fenomenes";
import * as ThieveIcon from "./../../constants/icons/fenomenes/hurtos/Hurtos";

import Form, { formTypes } from "../../Forms/Containers/FormCreator";

// import logo from './../../assetes/logo-encabezado.png';
// import footer from './../../assetes/pie-pagina2.png';
// import CNP from './ConvivenciaContainer';
// import Operatividad from './OperatividadContainer';
// import CRT from './CRTContainer';
import Generic from "./GenericContainer";
// import InformPage from "../componentes/InformPage";

import html2canvas from "html2canvas";

import { INFORM_GENERATOR } from "./../../constants/strings/StringsDashboard";

/* global jsPDF */

class Inform extends Component {
  state = {
    flangeActive: 1,
    loader: false,
    nav: true,
  };

  onGenerate = () => {
    this.setState({ loader: !this.state.loader, nav: !this.state.nav });
    setTimeout(() => {
      // let $paginas = document.getElementsByClassName("container-book-inform-download");
      var pdf = new jsPDF("l", "px", [1415, 1000]);
      html2canvas(document.getElementById("hom1"), {
        useCORS: true,
      }).then((canvas) => {
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        pdf.addImage(imgData, "JPEG", 0, 0, 1415, 1000);
        pdf.save("informe.pdf");
        this.setState({ loader: !this.state.loader, nav: !this.state.nav });
      });
    }, 10000);
  };

  handlerFlange = (item) => {
    const $girar = document.getElementById("girar");
    $girar.style.WebkitTransitionDuration = "1000ms";
    $girar.style.WebkitTransformOrigin = "left";
    $girar.style.webkitTransform = "rotateY(270deg)";
    setTimeout(() => {
      this.setState({ flangeActive: item });
      $girar.style.WebkitTransitionDuration = "0s";
      $girar.style.WebkitTransformOrigin = "left";
      $girar.style.webkitTransform = "rotateY(0deg)";
    }, 1000);
  };

  getFenom = () => {
    const flange = this.getflanges(this.state.flangeActive);
    return (
      <Generic
        midTittle={this.props.data.fecha}
        data={this.props.data.fenomenos
          .filter((f) => f.id === flange.id)
          .reduce((prev, curr) => curr, {})}
        idMap={"fen" + this.state.flangeActive}
        type={flange}
        gender={flange.id === 1 ? false : true}
        mod={false}
        med={[11, 100].includes(flange.id) ? false : true}
        // med={flange.id === 11 ? false : true}
        jorn={flange.id !== 100}
        zone={
          flange.id === 1 ? true : false
        }
        etar={[11, 100].includes(flange.id)}
        ap={flange.id === 100}
        perfil={INFORM_GENERATOR.ZONES_BY_ID.filter(
          (z) => z.id === this.props.zone
        ).reduce((prev, curr) => curr.value, "")}
      />
    );
  };

  getflanges = (flange) => {
    const flanges = [
      {
        fen: "Homicidios",
        item: 1,
        group: "cri",
        icon: FenIcon.HOMICIDIOS(),
        groupName: "Criminalidad",
        id: 5,
      },
      {
        fen: "Hurto a Personas",
        item: 2,
        group: "cri",
        icon: ThieveIcon.HURTO_PERSONA(),
        groupName: "Criminalidad",
        id: 6,
      },
      {
        fen: "Hurto a Residencias",
        item: 5,
        group: "cri",
        icon: ThieveIcon.HURTO_VIVIENDA(),
        groupName: "Criminalidad",
        id: 7,
      },
      {
        fen: "Hurto de Vehículos",
        item: 3,
        group: "cri",
        icon: ThieveIcon.HURTO_VEHICULO(),
        groupName: "Criminalidad",
        id: 8,
      },
      {
        fen: "Hurto de Motocicletas",
        item: 4,
        group: "cri",
        icon: ThieveIcon.HURTO_MOTO(),
        groupName: "Criminalidad",
        id: 9,
      },
      {
        fen: "Hurto comercio",
        item: 6,
        group: "cri",
        icon: ThieveIcon.HURTO_COMERCIO(),
        groupName: "Criminalidad",
        id: 10,
      },
      // {
      //   fen: "Abigetato",
      //   item: 10,
      //   group: "cri",
      //   icon: ThieveIcon.HURTO_ABIGETAO(),
      //   groupName: "Criminalidad",
      //   id: 1,
      // },
      {
        fen: "Lesiones Personales",
        item: 8,
        group: "con",
        icon: FenIcon.LESIONES_PERSONALES(),
        groupName: "Convivencia",
        id: 11,
      },
      {
        fen: "Delitos Sexuales",
        item: 9,
        group: "con",
        icon: FenIcon.DELITOS_SEXUALES(),
        groupName: "Convivencia",
        id: 3,
      },
      {
        fen: "Espacio Público",
        item: 10,
        group: "ep",
        icon: FenIcon.EP(),
        groupName: "Espacio Público",
        id: 100,
      },
    ];
    if (flange)
      return flanges
        .filter((f) => f.item === flange)
        .reduce((prev, curr) => curr, {});
    return flanges;
  };

  render() {
    const fecha = () => {
      let ya = new Date();
      const day = (day) => {
        switch (day.getDay()) {
          case 0:
            return "Domingo";
          case 1:
            return "Lunes";
          case 2:
            return "Martes";
          case 3:
            return "Miércoles";
          case 4:
            return "Jueves";
          case 5:
            return "Viernes";
          case 6:
            return "Sábado";
          default:
            return "";
        }
      };
      const month = (month) => {
        switch (month.getMonth()) {
          case 0:
            return "Enero";
          case 1:
            return "Febrero";
          case 2:
            return "Marzo";
          case 3:
            return "Abril";
          case 4:
            return "Mayo";
          case 5:
            return "Junio";
          case 6:
            return "Julio";
          case 7:
            return "Agosto";
          case 8:
            return "Septiembre";
          case 9:
            return "Octubre";
          case 10:
            return "Noviembre";
          case 11:
            return "Diciembre";
          default:
            return "";
        }
      };
      return (
        day(ya) +
        " " +
        ya.getDate() +
        " de " +
        month(ya) +
        " de " +
        ya.getFullYear()
      );
    };
    const { data } = this.props;
    return (
      <React.Fragment>
        {this.state.loader && (
          <div className="float row loader-style" align="center">
            <div className="loader"></div>
            <h4>
              <strong>Creando pdf...</strong>
            </h4>
          </div>
        )}
        <>
          <div className="container-general-inform">
            <div></div>
            <div className="container-book-inform">
              <div className="div-titulo-informes">
                <p className="estilo-titulo-informe">{data.titulo}</p>
                <p className="estilo-fecha-informe">{fecha()}</p>
              </div>
              <div id="girar" className="girar">
                {this.getFenom()}
              </div>
              <div className="footer-book-infomr">
                <div className="div-titulo-informes alto-footer-book-informe"></div>
              </div>
            </div>
            <div className="flange-container">
              {this.getflanges()
                .filter((filt) => {
                  return filt.item !== 12;
                })
                .map((flange, i) => {
                  return (
                    <Flange
                      onClick={this.handlerFlange}
                      data={flange}
                      isActive={flange.item === this.state.flangeActive}
                      key={"flange-key-" + i}
                    >
                      <SvgSetter
                        name={flange.group + flange.item}
                        width={40}
                        height={41}
                      >
                        {flange.icon}
                      </SvgSetter>
                    </Flange>
                  );
                })}
            </div>
          </div>
          <div style={{ height: "70px" }}>
            <Form
              // onReset={this.handleFormReset}
              onChange={this.handlerChange}
              objectCreator={[
                {
                  type: formTypes.div,
                  classContainer: "line line-40",
                },
                // {
                //     type: formTypes.submit,
                //     classContainer: "button-primary line line-10 text-center",
                //     label: "Descargar",
                // },
                {
                  type: formTypes.buttonclick,
                  classContainer: "button-secondary line line-10 text-center",
                  label: "Cancelar",
                  onClick: this.props.onCancel,
                  // onActive: ()=>{}
                },
                {
                  type: formTypes.div,
                  classContainer: "line line-40",
                },
              ]}
              onSubmit={this.onGenerate}
            />
          </div>
        </>
      </React.Fragment>
    );
  }
}

export default Inform;
